module.exports = __webpack_public_path__ + "img/1x.16012d6.jpg";